import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export const RootStyled = styled(Box)({
  marginTop: '25px',
});

export const ResponseBtn = styled(Button)({
  backgroundColor: '#1976d2',
  color: 'white',
  textTransform: 'none',
  '&:hover': { backgroundColor: '#1565c0' },
});

export const ActionsBtn = styled(Button)({
  minWidth: '30px',
  backgroundColor: '#1976d2',
  color: 'white',
  borderLeft: '1px solid white',
  '&:hover': { backgroundColor: '#1565c0' },
});
